<template>
  <div class="content-main">
    <BaseOrderModal
      @closeOrder="openedOrder = ''"
      :orderUUID="openedOrder"
      v-model="showOrderModal"
    />
    <template>
      <div class="content">
        <div class="header">
          Shipments
          <br />
          <button
            v-if="!sendingShipments"
            class="dark-button"
            @click="sendAllShipments()"
          >
            Send All Shipments
          </button>
          <div v-else>
            Sending Shipment ...
          </div>
          <button
            @click="openFileForm()"
            style="float: right;"
            class="warning-button"
          >
            Upload File
          </button>
        </div>
        <BaseModal v-model="showFileForm">
          <div class="file-uploader">
            <h2>Upload new Shipping report file</h2>
            <div class="body">
              <div v-if="!uploadingFile">
                <div class="input-box">
                  <input id="fileInput" type="file" @change="onFileChanged" />
                </div>
                <br />
                <button
                  id="upload-btn"
                  class="dark-button"
                  @click="submitUploadFile"
                >
                  Upload
                </button>
                <div v-if="fileUploadResponse && fileUploadResponse.length > 0">
                  <div v-for="(res, index) in fileUploadResponse" :key="index">
                    <div v-html="res"></div>
                  </div>
                </div>
              </div>
              <div v-else>
                <BaseSmallSpinner />
              </div>
            </div>
          </div>
        </BaseModal>
        <div class="table">
          <table class="default-table" v-if="!loading">
            <thead>
              <tr class="table100-head">
                <th
                  v-for="headerItem in tableHeaders"
                  :key="headerItem.value"
                  @click="changeArrowDir(headerItem.value)"
                >
                  {{ headerItem.displayText }}
                  <span v-if="filters.orderCol == headerItem.value">
                    <img
                      :src="
                        require(`@/assets/icons/${arrowDirection}-arrow.svg`)
                      "
                    />
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="shipment in shipments"
                :key="shipment.uuid"
                @click="selectedOrder = shipment.uuid"
                :class="{ selected: selectedOrder == shipment.uuid }"
              >
                <td class="shipments-column">
                  <a @click="openOrder(shipment.orderUuid)">
                    {{ shipment.orderNumber }}
                  </a>
                </td>
                <td>
                  {{ shipment.dateShipped }}
                </td>
                <td>
                  {{ shipment.carrier }}
                </td>
                <td>
                  {{ shipment.service }}
                </td>
                <td>
                  {{ shipment.tracking }}
                </td>
                <td>
                  {{ shipment.source }}
                </td>
                <td>
                  {{ shipment.salesman }}
                </td>
                <td>
                  {{
                    shipment.sourceSync == 0
                      ? "No"
                      : Shipment.sourceSync == -1
                      ? "Error"
                      : "Yes"
                  }}
                </td>
                <td>
                  <button
                    v-if="!sendingShipments"
                    class="dark-button"
                    @click="sendShipment(shipment)"
                  >
                    Send now
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <div v-else>
            Loading...
          </div>
        </div>
        <div class="footer">
          <div class="totals">
            showing {{ filters.limitPerPage * (filters.page - 1) }} to
            {{ toQuantity() }} from {{ totalItems }} results
          </div>
          <div class="pages">
            <!-- <select
              v-model="shipmentsByPage"
              @change="
                (filters.limitPerPage = shipmentsByPage), (filters.page = 1)
              "
            >
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
            </select>
            Per Page -->
          </div>
          <!-- <div class="pages">
            <div>
              <a
                :class="{ disabled: filters.page == 0 }"
                class="page-link"
                @click="previous()"
                >Previous</a
              >
            </div>
            <div>Page {{ filters.page }}</div>
            <div>
              <a
                :class="{
                  disabled: totalPages > filters.page
                }"
                class="page-link"
                @click="next()"
                >Next</a
              >
            </div>
          </div> -->
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {
  getShipments,
  sendShipmentToShipstation,
  uploaMamShippingFile,
  sendAllShipmentsToShipstation
} from "@/api/SyncSystem.js";
export default {
  name: "ShipmentsPage",
  data() {
    return {
      showOrderModal: false,
      sendingShipments: false,
      showFileForm: false,
      newShipmentFile: [],
      fileUploadResponse: [],
      uploadingFile: false,
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      filters: {
        statusSystem: "pending_to_be_sent",
        page: 1,
        limitPerPage: 1000,
        orderCol: "orderNumber",
        orderDir: "desc",
        search: ""
      },
      shipmentsByPage: 1000,
      systemCode: "mam",
      shipments: [],
      totalItems: 0,
      totalPages: 0,
      loading: true,
      selectedOrder: null,
      openedOrder: null,
      tableHeaders: [
        {
          displayText: "Order Number",
          value: "orderNumber"
        },
        {
          displayText: "Shipped Date",
          value: "shippedDate"
        },
        {
          displayText: "Carrier",
          value: "carrier"
        },
        {
          displayText: "service",
          value: "service"
        },
        {
          displayText: "Tracking",
          value: "tracking"
        },
        {
          displayText: "Source",
          value: "source"
        },
        {
          displayText: "Salesman",
          value: "salesman"
        },
        {
          displayText: "Sent to Source",
          value: "shipstation"
        },
        {
          displayText: "Action",
          value: "action"
        }
      ]
    };
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.loading = true;
        this.loadShipments();
      }
    }
  },
  computed: {
    arrowDirection() {
      return this.filters.orderDir == "desc" ? "down" : "up";
    }
  },
  mounted() {
    this.loadShipments();
  },
  methods: {
    updateSearchFilter(search) {
      this.filters.page = 1;
      this.filters.search = search;
    },
    logout() {
      this.$store.dispatch("auth/logOut");
      this.$router.push("/");
    },
    updateStatusFilter(status) {
      this.filters.page = 1;
      this.filters.statusSystem = status;
    },
    async loadShipments() {
      const res = await getShipments(this.filters).catch(() => {
        alert("Error getting shipments");
      });
      this.shipments = res.shipments;
      this.totalItems = res.totalItems;
      this.totalItems = res.totalItems;
      this.totalPages = res.totalPages;
      this.loading = false;
    },
    previous() {
      if (this.filters.page > 1) {
        this.filters.page = this.filters.page - 1;
      }
    },
    next() {
      if (this.totalItems >= this.filters.limitPerPage * this.filters.page) {
        this.filters.page = this.filters.page + 1;
      }
    },
    toQuantity() {
      if (this.qtyPerPage * this.page > this.totalItems) {
        return this.shipments.length;
      } else {
        return (
          this.filters.limitPerPage * (this.filters.page - 1) +
          this.shipments.length
        );
      }
    },
    changeArrowDir(headerValue) {
      this.filters.page = 1;
      if (headerValue == this.filters.orderCol) {
        this.filters.orderDir =
          this.filters.orderDir == "desc" ? "asc" : "desc";
      } else {
        this.filters.orderCol = headerValue;
        this.filters.orderDir = "desc";
      }
    },
    async sendShipment(shipment) {
      this.sendingShipments = true;
      let response = await sendShipmentToShipstation(shipment.uuid);
      if (response.status == "success") {
        this.$toast.open({
          message: `Shipment Sent succesfully`,
          type: "success",
          position: "top-right"
        });
        this.loadShipments();
      } else {
        this.$toast.open({
          message: `Error sending shipment`,
          type: "error",
          position: "top-right"
        });
      }
      this.sendingShipments = false;
    },
    async sendAllShipments() {
      this.sendingShipments = true;
      let response = await sendAllShipmentsToShipstation();
      this.$toast.open({
        message: `Shipments Sent: ${response.shipmentsSent}`,
        type: "success",
        position: "top-right"
      });
      if (response.errorSendingShipment > 0) {
        this.$toast.open({
          message: `Error Sending ${response.shipmentsSent} shipments`,
          type: "error",
          position: "top-right"
        });
      }
      this.loadShipments();
      this.sendingShipments = false;
    },
    submitUploadFile() {
      this.uploadingFile = true;
      if (this.newShipmentFile && this.newShipmentFile.length > 0) {
        this.uploadFile(this.newShipmentFile)
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            return true;
          })
          .catch(e => {
            console.log(e);
          })
          .finally(() => {
            console.log("finally");
            this.newShipmentFile = null;
            // document.getElementById("fileInput").value = "";
            this.loadShipments();
            this.uploadingFile = false;
          });
      } else {
        this.fileUploadResponse.push(`No file uploaded`);
        return;
      }
    },
    uploadFile(file) {
      this.fileUploadResponse = [];
      return uploaMamShippingFile(file).then(res => {
        console.log(res);
        if (res.status == "success") {
          this.$toast.open({
            message: `${res.totalShipmentsInserted} Shipments inserted`,
            type: "success",
            position: "top-right"
          });
          this.fileUploadResponse.push(
            `${res.totalShipmentsInserted} Shipments inserted, ${res.originalResponse.ordersUpdated} orders updated.`
          );
          if (res.originalResponse.shipmentsErrorsMessages?.length > 0) {
            res.originalResponse.shipmentsErrorsMessages.forEach(element => {
              this.fileUploadResponse.push(element.message);
            });
          }
        }
        return res;
      });
    },
    onFileChanged() {
      var fileList = [];
      for (var i = 0; i < event.target.files.length; i++) {
        fileList.push(event.target.files[i]);
      }
      this.newShipmentFile = fileList;
    },
    openFileForm() {
      this.fileUploadResponse = [];
      this.showFileForm = true;
    },
    openOrder(orderUUID) {
      this.openedOrder = orderUUID;
      this.showOrderModal = true;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.content-main {
  .content {
    padding: 5px;
    width: 100%;
    overflow-x: auto;
    .file-uploader {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      .body {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        min-height: 250px;
      }
      h2 {
        font-weight: 700;
        font-size: 20px;
        width: 100%;
        text-align: center;
      }
      #upload-btn {
        width: 80px;
        margin: 10px auto;
      }
      .input-box {
        width: 250px;
        margin: 20px auto;
        input {
          text-align: center;
        }
      }
    }
    .header {
      width: 100%;
      padding: 20px 15px;
    }
    .table {
      width: 100%;
      height: calc(100% - 200px);
      overflow-x: auto;
      margin-bottom: 10px;
      .products-column {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        vertical-align: middle;
      }
      .shipments-column {
        max-width: 200px;
        min-width: 200px;
      }
      table {
        td {
          font-size: 14px;
          white-space: nowrap;
        }
        a {
          font-size: 14px;
        }
      }
    }
    .footer {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
      .pages {
        display: flex;
        flex-direction: row;
        div {
          width: 75px;
        }
        .page-link {
          color: $link-color-1;
        }
      }
    }
  }
}
</style>
